import type { IUser, UserState, UserJoinStage } from 'oscar-typedef'
export class User {
  id: string
  email: string
  name: string
  localeId: number
  currencyId: number
  lastAccessDevice: string
  lastAccessTime: string
  lastSessionIp: string
  createdTime: string
  userJoinStage: UserJoinStage
  profileImage: string
  userState: UserState
  use2FA: number

  constructor(user: IUser) {
    this.id = user.id
    this.email = user.email
    this.name = user.name
    this.localeId = user.localeId
    this.currencyId = user.currencyId
    this.lastAccessDevice = user.lastAccessDevice
    this.lastAccessTime = user.lastAccessTime
    this.lastSessionIp = user.lastSessionIp
    this.createdTime = user.createdTime
    this.userJoinStage = user.userJoinStage
    this.profileImage = user.profileImage
    this.userState = user.userState
    this.use2FA = user.use2FA
  }
}
